import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "flex gap-x1 items-center" }
const _hoisted_2 = { class: "c-magic-line c-magic-line--underline whitespace-nowrap text-dusty-grey" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ModuleConfiguratorButton',
  props: {
    label: { default: undefined }
  },
  setup(__props: any) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", _hoisted_1, [
      _createElementVNode("span", _hoisted_2, _toDisplayString(__props.label), 1)
    ])
  ]))
}
}

})